export const TAG_COLORS = [
  "#F06050", "#F4A460", "#F7CD1F", "#6CC1ED", "#814968",
  "#EB7E7F", "#2C8397", "#475577", "#D6145F", "#30C381", "#9365B8"
];